import React, { Component } from "react";
import { Modal, Image, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { get } from "lodash";
import { PATHS } from "../../constant";
import { getColor, dateFormat } from "../../helper";
import { AILoader } from "../../component/Loader";
import {
  getAIissueSummary,
  getsimilarIssues,
  gettimelinePrediction,
  aiQuestions,
  getissueUpdates,
  getactionRecommendation
} from "../../services/apiServices";
import { RedirectUser } from "../reusableComponent";
import request from "../../services/requestService";
import StarIcon from "../../assets/start_Icon.svg";
import AI_smmary_GreyIcon from "../../assets/AI_smmary_GreyIcon.svg";
import AI_Summary_White_icon from "../../assets/AI_Summary_White icon.svg";
import ai_disclaimer from "../../assets/ai_disclaimer.svg";
import Similar_Issue_grey_icon from "../../assets/Similar-Issue-grey-icon.svg";
import similar_issue_white_icon from "../../assets/similar-issue-white-icon.svg";
import Issue_Update_Grey_Icon from "../../assets/Issue_Update_Grey_Icon.svg";
import Issue_Update_white_Icon from "../../assets/Issue_Update_white_Icon.svg";
import Recom_action_grey from "../../assets/Recom_action_grey.svg";
import Recom_Action_white_icon from "../../assets/Recom_Action_white_icon.svg";
import AI_Predict_Star from "../../assets/AI_Predict_Star.svg";
import AI_Calander_Icon from "../../assets/AI_Calander_Icon.svg";
import AI_Separator from "../../assets/AI_Separator.svg";
import star_yellow from "../../assets/star_icon.svg";
import icon_verified from "../../assets/icon-verified.png";
import issue_update_icon1 from "../../assets/issue_update_icon1.svg";
import issue_update_icon2 from "../../assets/issue_update_icon2.svg";
import issue_update_icon3 from "../../assets/issue_update_icon3.svg";
import issue_update_icon4 from "../../assets/issue_update_icon4.svg";
import AI_Similarity_heading from "../../assets/AI Similarity heading.svg";
import AI_Analysis from "../../assets/AI Analysis.svg";
import long_description_icon from "../../assets/long_description_icon.svg";
import short_description_icon from "../../assets/short_description_icon.svg";
import Immediate_Icon from "../../assets/Immediate_Icon.svg";
import learn_icon from "../../assets/learn_icon.svg";
import Strategic_Icon from "../../assets/Strategic_Icon.svg";
import AI_Question_Icon from "../../assets/AI_Question_Icon.svg";
import Separator_AI from "../../assets/Separator_AI.svg";
import IssueTooltip from "./IssueTooltip";
import IndiaAI_Logo from "../../assets/IndiaAI_Logo.png";
import starReason from "../../assets/analysis-icon.svg";
import xss from "xss";
import { toolttipDisplayMessage } from "../issueList/helper";
import AISimilaritiesAnalysis from "../projectDetails/AISimilaritiesAnalysis";
export class AISummaryModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      isLoading: false,
      activeTab: "AI Summary",
      isLoaderActive: true,
      long_summary: "",
      short_summary: "",
      predictedEndDate: "",
      tentativeResolutionDate: "",
      similarIssuesData: [],
      meetingData: [],
      insightsData: [],
      questions: [],
      immediateNextSteps: "",
      learnFromSimilarIssues: "",
      strategicBestPractice: "",
      actionRecommendationRes: "",
      timelineReasoning: ""
    };
    this.flagTimer = null;
  }
  componentDidMount = async () => {
    const { issueData } = this.props;

    this.setState({ isLoaderActive: true });

    const issueId = get(issueData, "id", null);
    const projectId = get(issueData, "projectId");

    const payload = {
      issue_id: issueId,
      project_id: projectId
    };

    try {
      const [
        issueSummaryRes,
        similarIssueRes,
        timelinePredictionRes,
        aiQuestionsRes,
        issueUpdatesRes,
        actionRecommendationRes
      ] = await Promise.all([
        request(getAIissueSummary(payload)),
        request(getsimilarIssues(payload)),
        request(gettimelinePrediction(payload)),
        request(aiQuestions(payload)),
        request(getissueUpdates(payload)),
        request(getactionRecommendation(payload))
      ]);
      this.setState({
        long_summary: get(issueSummaryRes, "data.data.longSummary", ""),
        short_summary: get(issueSummaryRes, "data.data.shortSummary", ""),
        similarIssuesData: get(similarIssueRes, "data.data.issues", []),
        timelineReasoning: get(
          timelinePredictionRes,
          "data.data.data.timelineReasoning",
          ""
        ),
        predictedEndDate: get(
          timelinePredictionRes,
          "data.data.data.predictedEndDate",
          null
        ),
        tentativeResolutionDate: get(
          timelinePredictionRes,
          "data.data.data.tentativeResolutionDate"
        ),
        questions: get(aiQuestionsRes, "data.data.questions", []),
        meetingData: get(issueUpdatesRes, "data.data.updates", []),
        actionRecommendationRes: get(actionRecommendationRes, "data.data.data"),
        insightsData: [
          {
            title: "Immediate Next Step",
            description: get(
              actionRecommendationRes,
              "data.data.data.immediateNextSteps",
              ""
            ),
            icon: <Image src={Immediate_Icon} />,
            color: "red"
          },
          {
            title: "Learning from Similar Issues",
            description: get(
              actionRecommendationRes,
              "data.data.data.learnFromSimilarIssues",
              ""
            ),
            icon: <Image src={learn_icon} />,
            color: "yellow"
          },
          {
            title: "Strategic Best Practice",
            description: get(
              actionRecommendationRes,
              "data.data.data.strategicBestPractice",
              ""
            ),
            icon: <Image src={Strategic_Icon} />,
            color: "green"
          }
        ]
      });
    } catch (error) {
      console.error("AI API error:", error);
    } finally {
      this.setState({ isLoaderActive: false });
    }
  };

  componentWillUnmount() {
    // Prevent memory leak
    if (this.flagTimer) {
      clearTimeout(this.flagTimer);
    }
  }
  handleTabChange = tab => {
    this.setState({ activeTab: tab });
  };

  onClose = () => {
    this.props.onClick(false);
  };
  formatDate = timestamp => {
    if (!timestamp) return "-";

    return new Date(timestamp).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  };

  renderTabContent = () => {
    const {
      activeTab,
      short_summary,
      long_summary,
      similarIssuesData,
      meetingData,
      predictedEndDate,
      tentativeResolutionDate,
      insightsData,
      questions,
      actionRecommendationRes,
      timelineReasoning
    } = this.state;
    const { issueData } = this.props;
    switch (activeTab) {
      case "AI Summary":
        return (
          <>
            {short_summary == "" || long_summary == "" ? (
              <div className="nodataFound-container">
                <Image src="https://pmiic-local-files.s3.ap-south-1.amazonaws.com/no_data_found.png" />
                <h3 className={`no-data-found`}>No Data Found</h3>
              </div>
            ) : (
              <>
                <div class="issue-list-top" style={{ padding: 0 }}>
                  <div className="issue-list-header">
                    <span
                      className={`issue-number ${
                        get(issueData, "duplicate")
                          ? "duplicate-issue-number"
                          : ""
                      }`}
                    >
                      {get(issueData, "duplicate")
                        ? "Duplicate Issue"
                        : "Issue"}{" "}
                      <b>
                        <a
                          href={`${PATHS.ISSUE_DETAIL}?issueId=${get(
                            issueData,
                            "id"
                          )}&projectId=${get(issueData, "projectId")}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          #{issueData.projectIssueDTO.displayId}-
                          {get(issueData, "id")}
                        </a>
                      </b>
                    </span>
                    <h2
                      className={`issue-title ${
                        /[\u0900-\u097F]/.test(get(issueData, "title"))
                          ? "hindi-text-wrap-comment"
                          : ""
                      }`}
                    >
                      {get(issueData, "title", null)}
                    </h2>
                  </div>
                  <Button
                    className={`btn-mod ${getColor(
                      get(issueData, "issueStatusName", null) ||
                        get(issueData, "status", null)
                    )} animated flipY unClickable`}
                    style={{ borderRadius: "20px", marginRight: "0em" }}
                  >
                    {get(issueData, "issueStatusName", null) ||
                      get(issueData, "status", null)}
                  </Button>
                  {/* <div class="issue-list-status">
                    <Button
                      className={`btn-extra-small animated flipInX ${getColor(
                        get(issueData, "issueStatusName", null) ||
                          get(issueData, "status", null)
                      )} unClickable`}
                    >
                      {get(issueData, "issueStatusName", null) ||
                        get(issueData, "status", null)}
                    </Button>
                  </div> */}
                </div>
                <div style={{ display: "flex", gap: "10px" }}>
                  <div className="prediction-pill">
                    <div className="icon-circle">
                      {/* <Image src={AI_Separator} className="ai_sepator" /> */}
                    </div>

                    <span className="label-text">
                      Tentative Resolution Date:
                    </span>
                    <div className="date-box-tentative">
                      <Image
                        src={AI_Calander_Icon}
                        style={{
                          filter: "brightness(0) invert(1)",
                          width: "16px"
                        }}
                      />
                      <span style={{ paddingTop: "2px", paddingRight: "7px" }}>
                        {tentativeResolutionDate === null ||
                        tentativeResolutionDate === ""
                          ? " "
                          : tentativeResolutionDate}
                      </span>
                    </div>
                  </div>
                  <div className="prediction-pill">
                    <div className="icon-circle">
                      {/* <Image src={AI_Predict_Star} /> */}
                      {/* <Image src={starReason} style={{ width: "28px"}} /> */}
                      <IssueTooltip
                        marginLeft={true}
                        activeTab={activeTab}
                        tooltipContent={
                          <>
                            <div className="ai-modal-header">
                              <Image src={AI_Analysis} />
                            </div>

                            {(() => {
                              const analysis = timelineReasoning || "";
                              const sentenceCount = analysis
                                ? analysis.split(".").filter(s => s.trim())
                                    .length
                                : 0;

                              return sentenceCount > 1 ? (
                                <ol className="ai-points">
                                  {analysis
                                    .split(".")
                                    .filter(s => s.trim())
                                    .map((point, i) => (
                                      <li key={i}>{point}.</li>
                                    ))}
                                </ol>
                              ) : (
                                <ol
                                  className="ai-points"
                                  style={{ marginLeft: null }}
                                >
                                  {analysis || "N/A"}
                                </ol>
                              );
                            })()}
                          </>
                        }
                      >
                        <Image
                          src={starReason}
                          // className="sparkle_image"
                          style={{ width: "28px", marginLeft: "4px" }}
                        />
                      </IssueTooltip>
                      <Image src={AI_Separator} className="ai_sepator" />
                    </div>

                    <span className="label-text">
                      AI Predicted Resolution Date:
                    </span>
                    <div className="date-box">
                      <Image
                        src={AI_Calander_Icon}
                        style={{
                          filter: "brightness(0) invert(1)",
                          width: "16px"
                        }}
                      />
                      <span style={{ paddingTop: "2px", paddingRight: "7px" }}>
                        {predictedEndDate === null || predictedEndDate === ""
                          ? ""
                          : predictedEndDate}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="description-card">
                  <h3>
                    <Image src={short_description_icon} />
                    <span className="ai-description-text"> Short Summary</span>
                  </h3>
                  {/* <p>{short_summary}</p> */}

                  {/* <p
                    style={{ whiteSpace: "pre-line" }}
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(short_summary)
                    }}
                  /> */}
                  <p
                    style={{ whiteSpace: "pre-line" }}
                    dangerouslySetInnerHTML={{
                      __html: xss(short_summary)
                    }}
                  />
                </div>
                <div
                  className="description-card"
                  style={{ backgroundColor: "#fff" }}
                >
                  <h3>
                    <Image src={long_description_icon} />{" "}
                    <span className="ai-description-text">
                      Detailed Summary
                    </span>
                  </h3>
                  <p
                    style={{ whiteSpace: "pre-line" }}
                    dangerouslySetInnerHTML={{
                      __html: xss(long_summary)
                    }}
                  />
                  {/* <p
                    style={{ whiteSpace: "pre-line" }}
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(long_summary)
                    }}
                  /> */}

                  {/* <p style={{ whiteSpace: "pre-line" }}>{long_summary}</p> */}
                </div>
              </>
            )}
          </>
        );

      case "Similar Issues":
        return (
          <>
            {similarIssuesData.length == 0 ? (
              <div className="nodataFound-container">
                <Image src="https://pmiic-local-files.s3.ap-south-1.amazonaws.com/no_data_found.png" />
                <h3 className={`no-data-found`}>No Data Found</h3>
              </div>
            ) : (
              <>
                {" "}
                {similarIssuesData.map((issue, index) => {
                  const isLast = index === similarIssuesData.length - 1;

                  return (
                    <div
                      className="issue-card"
                      key={issue.issueId}
                      style={{ marginBottom: isLast ? "5px" : "17px" }}
                    >
                      <div className="issue-header">
                        <div>
                          <span className="issue-id">
                            ISSUE{" "}
                            <a
                              href={`${PATHS.ISSUE_DETAIL}?issueId=${
                                issue.issueId
                              }&projectId=${issue.projectId}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              #{issue.displayId}-{issue.issueId}
                            </a>
                          </span>

                          <h2 className="issue-title">
                            {issue.issueTitle}

                            <IssueTooltip
                              tooltipContent={
                                <>
                                  <div className="ai-modal-header">
                                    <Image src={AI_Similarity_heading} />
                                  </div>

                                  {(() => {
                                    const analysis =
                                      issue.similarIssueAnalysis || "";
                                    const sentenceCount = analysis
                                      ? analysis
                                          .split(".")
                                          .filter(s => s.trim()).length
                                      : 0;

                                    return sentenceCount > 1 ? (
                                      <ol className="ai-points">
                                        {analysis
                                          .split(".")
                                          .filter(s => s.trim())
                                          .map((point, i) => (
                                            <li key={i}>{point}.</li>
                                          ))}
                                      </ol>
                                    ) : (
                                      <ol
                                        className="ai-points"
                                        style={{ marginLeft: null }}
                                      >
                                        {analysis || "N/A"}
                                      </ol>
                                    );
                                  })()}
                                </>
                              }
                            >
                              <Image
                                src={star_yellow}
                                className="sparkle_image"
                              />
                            </IssueTooltip>
                          </h2>
                        </div>
                        <Button
                          className={`btn-mod ${getColor(
                            issue.status
                          )} animated flipY unClickable`}
                          style={{
                            borderRadius: "20px",
                            marginTop: "0.1em",
                            marginRight: "initial"
                          }}
                        >
                          {issue.status}
                        </Button>

                        {/* STATUS */}

                        {/* <OverlayTrigger
                                defaultShow={false}
                                placement="top"
                                overlay={
                                  <Tooltip className={"issues-status-tooltip"}>
                                    {toolttipDisplayMessage(issue.status)}
                                  </Tooltip>
                                }
                              >
                                <div>
                                  <Button
                                    className={`btn-mod ${getColor(
                                      issue.status
                                    )} animated flipY unClickable`}
                                    style={{ borderRadius: "20px" }}
                                  >
                                    {issue.status}
                                  </Button>
                                </div>
                              </OverlayTrigger> */}

                        {/* <Button
                          className={`btn-extra-small ${getColor(
                            issue.status
                          )} unClickable`}
                        >
                          {issue.status}
                        </Button> */}
                      </div>

                      {/* DETAILS */}
                      <div className="issue-details">
                        <p>
                          <strong>Issue Location</strong>
                          <span> - {issue.location}</span>
                        </p>

                        <p>
                          <strong>Issue District/Department</strong>
                          <span> - {issue.disDept}</span>
                        </p>

                        <p>
                          <strong>Issue Category</strong>
                          <span> - {issue.category}</span>
                        </p>

                        <p>
                          <strong>Resolution Time</strong> -{" "}
                          <span className="resolution-time">
                            {issue.resolutionTime
                              ? `${issue.resolutionTime} days`
                              : "N/A"}
                          </span>{" "}
                        </p>
                      </div>

                      {/* FOOTER */}
                      <div className="issue-footer">
                        <Image src={icon_verified} style={{ width: 15 }} />

                        <span className="first-pp-name">
                          <RedirectUser
                            title={issue.createBy}
                            id={issue.createdById}
                            isProjectProponentDetail={true}
                          />
                        </span>

                        <span className="ai_seperator">|</span>

                        <span className="verified-date">
                          Verified on: {dateFormat(issue.verifiedOn)}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </>
        );

      case "Meeting Directions":
        return (
          <>
            {meetingData.length == 0 ? (
              <div className="nodataFound-container">
                <Image src="https://pmiic-local-files.s3.ap-south-1.amazonaws.com/no_data_found.png" />
                <h3 className={`no-data-found`}>No Data Found</h3>
              </div>
            ) : (
              <div className="meeting-table-wrapper">
                <table className="meeting-table">
                  <thead>
                    <tr>
                      <th>
                        <Image src={issue_update_icon1} /> Meeting Date
                      </th>
                      <th>
                        <Image src={issue_update_icon2} /> Chaired By
                      </th>
                      <th>
                        <Image src={issue_update_icon3} /> Action Items
                      </th>
                      <th>
                        <Image src={issue_update_icon4} />
                        Tentative Resolution Date
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {meetingData.map((item, index) => (
                      <tr key={index}>
                        <td>{this.formatDate(item.meetingDate)}</td>
                        <td>{item.meetingChairedBy}</td>
                        <td>{item.actionItem}</td>
                        <td>{this.formatDate(item.tentativeResolutionDate)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        );

      case "Recommended Action Items":
        return (
          <>
            {questions.length == 0 && actionRecommendationRes == null ? (
              <div className="nodataFound-container">
                <Image src="https://pmiic-local-files.s3.ap-south-1.amazonaws.com/no_data_found.png" />
                <h3 className={`no-data-found`}>No Data Found</h3>
              </div>
            ) : (
              <>
                <div
                  className="insights-wrapper"
                  style={{
                    display: actionRecommendationRes == null ? "none" : null
                  }}
                >
                  {insightsData.map((item, index) => (
                    <div className={`insight-card ${item.color}`} key={index}>
                      <div className={`insight-icon ${item.color}`}>
                        {item.icon}
                      </div>

                      <div className="insight-content">
                        <h4>{item.title}</h4>
                        <p>{item.description}</p>
                      </div>

                      <div className="bottom-accent" />
                    </div>
                  ))}
                </div>
                <div
                  style={{
                    display: actionRecommendationRes == null ? "none" : null,
                    marginTop: 30
                  }}
                >
                  <Image src={Separator_AI} />
                </div>
                <div
                  className="ai-questions-container"
                  style={{ display: questions.length == 0 ? "none" : null }}
                >
                  {/* Header */}
                  <div className="ai-questions-header">
                    <div className="ai-icon">
                      <Image src={AI_Question_Icon} />
                    </div>
                    <h2>AI-Generated Questions for Next Meeting</h2>
                  </div>

                  {/* Questions */}
                  <div className="ai-questions-list">
                    {questions && questions.length > 0
                      ? questions.map((q, index) => (
                          <div className="ai-question-card" key={q.id || index}>
                            <div className="ai-question-badge">{`Q${index +
                              1}`}</div>
                            <p className="ai-question-text">
                              {q.question || "N/A"}
                            </p>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </>
            )}
          </>
        );

      default:
        return null;
    }
  };

  render() {
    const { activeTab, isLoaderActive } = this.state;
    const { isOpen, issueData } = this.props;

    const tabs = [
      {
        key: "AI Summary",
        label: "AI Summary",
        defaultIcon: (
          <Image src={AI_smmary_GreyIcon} style={{ marginBottom: -4 }} />
        ),
        activeIcon: (
          <Image src={AI_Summary_White_icon} style={{ marginBottom: -4 }} />
        )
      },
      {
        key: "Similar Issues",
        label: "Similar Issues",
        defaultIcon: <Image src={Similar_Issue_grey_icon} />,
        activeIcon: <Image src={similar_issue_white_icon} />
      },
      {
        key: "Meeting Directions",
        label: "Meeting Directions",
        defaultIcon: <Image src={Issue_Update_Grey_Icon} />,
        activeIcon: <Image src={Issue_Update_white_Icon} />
      },
      {
        key: "Recommended Action Items",
        label: "Recommended Action Items",
        defaultIcon: <Image src={Recom_action_grey} />,
        activeIcon: <Image src={Recom_Action_white_icon} />
      }
    ];

    const modifiedTab = tabs.filter(val =>
      get(issueData, "issueStatusName", null) == "Resolved"
        ? val.key !== "Recommended Action Items"
        : val
    );

    return (
      <>
        {isLoaderActive && <AILoader loading={isLoaderActive} />}

        {isOpen && !isLoaderActive && (
          <Modal
            show={isOpen}
            onHide={this.onClose}
            dialogClassName="ai-summary-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <div class="ai-header-wrapper">
                  <div class="ai-header-content">
                    <Image src={StarIcon} alt="Time" />
                    <div class="ai-text">
                      <div class="ai-title">AI Insights</div>
                      <div class="ai-subtitle">
                        Analysis for issue #
                        {issueData.projectIssueDTO.displayId}-
                        {get(issueData, "id", null)}
                      </div>
                    </div>
                  </div>
                  <div
                    class="ai-powered-by"
                    style={{
                      marginLeft: "24.2em",
                      background: "#fff",
                      borderRadius: "4px",
                      padding: "10px"
                    }}
                  >
                    <span class="powered-text" style={{ color: "black" }}>
                      POWERED BY
                    </span>
                    <Image src={IndiaAI_Logo} class="ai-logo" />
                  </div>
                </div>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="p-0">
              <div className="ai-container">
                {/* Tabs */}
                <div className="ai-tabs">
                  <div
                    className="tab-slider"
                    style={{
                      width: `${100 / modifiedTab.length}%`,
                      transform: `translateX(${modifiedTab.findIndex(
                        t => t.key === activeTab
                      ) * 100}%)`,
                      marginLeft:
                        modifiedTab.findIndex(t => t.key === activeTab) === 0
                          ? "12px"
                          : modifiedTab.findIndex(t => t.key === activeTab) ===
                            modifiedTab.length - 1
                          ? "-10px"
                          : "0px"
                    }}
                  />

                  {modifiedTab.map(tab => (
                    <div
                      key={tab.key}
                      className={`tab ${activeTab === tab.key ? "active" : ""}`}
                      onClick={() => this.handleTabChange(tab.key)}
                    >
                      <span className="tab-icon">
                        {activeTab === tab.key
                          ? tab.activeIcon
                          : tab.defaultIcon}
                      </span>
                      <span
                        className="tab-label"
                        style={{
                          marginLeft: tab.key == "AI Summary" ? -4 : null
                        }}
                      >
                        {tab.label}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Content Card */}
                <div className="content-card">
                  {this.renderTabContent()}

                  <div className="ai_disclaimer_div">
                    <Image src={ai_disclaimer} />{" "}
                    <span className="ai_disclaimer_text">Disclaimer:</span>{" "}
                    <span style={{ verticalAlign: "text-top" }}>
                      The responses are AI-generated and may not be fully
                      accurate; please verify with official PMG records.
                    </span>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        )}
      </>
    );
  }
}
